const LEGEND_ITEMS = [
  { label: 'livre', dotClassName: 'border border-border' },
  { label: 'ocupado', dotClassName: 'bg-chip' },
  { label: 'aula fixa', dotClassName: 'bg-primary' },
];

export function SlotLegend() {
  return (
    <div className="flex gap-4 text-xs text-ink-secondary">
      {LEGEND_ITEMS.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <span className={`h-2.5 w-2.5 rounded-full ${item.dotClassName}`} />
          {item.label}
        </span>
      ))}
    </div>
  );
}
